/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiClientsIdMutationRequest,
  PutApiClientsIdMutationResponse,
  PutApiClientsIdPathParams,
} from '../models/PutApiClientsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiClientsIdMutationResponseSchema,
  putApiClientsIdMutationRequestSchema,
} from '../zod/putApiClientsIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiClientsIdMutationKey = () =>
  [{ url: '/api/clients/:id' }] as const;

export type PutApiClientsIdMutationKey = ReturnType<
  typeof putApiClientsIdMutationKey
>;

/**
 * {@link /api/clients/:id}
 */
export async function putApiClientsId(
  id: PutApiClientsIdPathParams['id'],
  data: PutApiClientsIdMutationRequest,
  config: Partial<RequestConfig<PutApiClientsIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiClientsIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiClientsIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiClientsIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/clients/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiClientsIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/clients/:id}
 */
export function usePutApiClientsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiClientsIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiClientsIdPathParams['id'];
        data: PutApiClientsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiClientsIdMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiClientsIdMutationKey();

  return useMutation<
    PutApiClientsIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiClientsIdPathParams['id'];
      data: PutApiClientsIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiClientsId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
